import PopupMessage from 'components/popup-message'
import { CLICK_ACTION_1_POPUP_MESSAGE, CLICK_ACTION_2_POPUP_MESSAGE, CLICK_ACTION_POPUP_MESSAGE } from 'constants/common'
import eventEmitter from 'help/eventEmitter'
import React, { createContext, useState } from 'react'
const PopupMessageContext = createContext(null)
export const PopupMessageProvider = ({ children }) => {
  const [btn, setBtn] = useState({
    nameBtn: '',
    nameBtn1: '',
    nameBtn2: '',
  })
  const [content, setContent] = useState('')
  const [groupBtnBlock, setGroupBtnBlock] = useState(false)
  const [isShowPopup, setIsShowPopup] = useState(false)
  const togglePopupMessage = (bool) => {
    setIsShowPopup(bool)
  }
  const clickAction = (e) => {
    eventEmitter.emit(CLICK_ACTION_POPUP_MESSAGE, e)
  }
  const clickAction1 = (e) => {
    eventEmitter.emit(CLICK_ACTION_1_POPUP_MESSAGE, e)
  }
  const clickAction2 = (e) => {
    eventEmitter.emit(CLICK_ACTION_2_POPUP_MESSAGE, e)
  }
  const resetPopupMessage = () => {
    setContent('')
    setBtn({
      nameBtn: '',
      nameBtn1: '',
      nameBtn2: '',
    })
  }
  const setNameBtn = (key, value) => {
    setBtn((prev) => ({
      ...prev,
      [key]: value,
    }))
  }
  const showPopupMessage = (content, nameBtn) => {
    setContent(content)
    setNameBtn('nameBtn', nameBtn)
    togglePopupMessage(true)
  }
  const showPopupMessageMultiBtn = (content, nameBtn1, nameBtn2, groupBtnBlock) => {
    setContent(content)
    setNameBtn('nameBtn1', nameBtn1)
    setNameBtn('nameBtn2', nameBtn2)
    setGroupBtnBlock(groupBtnBlock)
    togglePopupMessage(true)
  }
  const closePopupMessage = () => {
    resetPopupMessage()
    togglePopupMessage(false)
  }
  return (
    <PopupMessageContext.Provider
      value={{
        isShowPopup,
        togglePopupMessage,
        resetPopupMessage,
        showPopupMessage,
        closePopupMessage,
        showPopupMessageMultiBtn,
      }}
    >
      {children}
      {isShowPopup && (
        <PopupMessage
          btn={btn}
          content={content}
          groupBtnBlock={groupBtnBlock}
          clickAction={clickAction}
          clickAction1={clickAction1}
          clickAction2={clickAction2}
        />
      )}
    </PopupMessageContext.Provider>
  )
}
export default PopupMessageProvider
export { PopupMessageContext }
